export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY'
export const DEFAULT_HOURS_FORMAT = 'HH'
export const DEFAULT_MINUTES_FORMAT = 'mm'
export const DEFAULT_TIME_FORMAT = `${DEFAULT_HOURS_FORMAT}:${DEFAULT_MINUTES_FORMAT}`
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
export const UTC_DATE_FORMAT = 'YYYY-MM-DD'
export const UTC_TIME_FORMAT = `${UTC_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
export const EXPORT_DATE_TIME_FORMAT = `DD_MM_YYYY_HH:mm`
